/* ============
 * Transfer Transformer
 * ============
 */

import Transformer from './transformer';
import productTrans from './transferProduct';
import stockTrans from './stock';
import warehouseTrans from './warehouse';
import moment from 'moment';

export default class TransferTransformer extends Transformer {

  static fetch(transfer) {
    return {
      id: transfer.id,
      code: transfer.code,
      name: transfer.name,
      batchId: transfer.batch_id,
      status: transfer.status,
      transferType: transfer.transfer_type,
      transferTypeName: transfer.transfer_type_name,
      date: moment(transfer.transfer_date).format('MM-DD-YYYY'),
      fromWarehouseId: transfer.from_warehouse_id,
      fromWarehouse: transfer.from_warehouse !== undefined ? warehouseTrans.fetch(transfer.from_warehouse) : [],
      toWarehouseId: transfer.to_warehouse_id,
      toWarehouse: transfer.to_warehouse !== undefined ? warehouseTrans.fetch(transfer.to_warehouse) : [],
      comments: transfer.comments,
      createdAt: transfer.created_at,
      products: transfer.products !== undefined ? productTrans.fetchCollection(transfer.products) : [],
      stock: transfer.stock !== undefined ? stockTrans.fetch(transfer.stock) : [],
      warehouse: transfer.warehouse !== undefined ? warehouseTrans.fetch(transfer.warehouse) : [],
      toWarehouseName: transfer.to_warehouse_name,
      fromWarehouseName: transfer.from_warehouse_name,
    };
  }

  static send(transfer) {
    return {
      transfer_type: transfer.transferType,
      date: transfer.date,
      from_warehouse_id: transfer.fromWarehouseId,
      to_warehouse_id: transfer.toWarehouseId,
      batch_id: transfer.batchId,
      comments: transfer.comments,
      products: productTrans.sendCollection(transfer.products),
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/transfer.js